import { Star } from "lucide-react";

export const Stars = ({ value = 0, size = "h-4 w-4", onChange, testId }) => (
  <span className="inline-flex items-center gap-0.5" data-testid={testId}>
    {[1, 2, 3, 4, 5].map((n) => {
      const cls = `${size} ${n <= Math.round(value) ? "fill-[#d4f253] text-[#d4f253]" : "text-slate-500"}`;
      return onChange ? (
        <button key={n} type="button" data-testid={`${testId}-${n}`} onClick={() => onChange(n)} className="transition-transform hover:scale-110"><Star className={cls} /></button>
      ) : <Star key={n} className={cls} />;
    })}
  </span>
);
